import {createSlice, current} from '@reduxjs/toolkit';

const initialState = {
  initialLoading: true,
  loading: false,
  extraConfigParam: {},
  loginToRoomOtpRequiredFlag: false,
  webAppWidgetsInfo: {},
  currentLayout: {},
  currentLayoutId: null,
  currencyDetails: {},
  brandingColors: {},
  currentWidget: {},
  error: false,
  errorMessage: ''
};

const deviceConfigSlice = createSlice({
  name: 'deviceConfig',
  initialState,
  reducers: {
    resetDeviceConfig: () => initialState,
    initDeviceConfigRequest: state => {
      state.loading = true;
      state.error = false;
      state.errorMessage = '';
    },
    getDeviceConfigSuccess: (state, action) => {
      state.initialLoading = false;
      state.loading = false;
      state.loginToRoomOtpRequiredFlag = action.payload.loginToRoomOtpRequiredFlag;
      state.extraConfigParam = action.payload.extraConfigParam;
      state.webAppWidgetsInfo = action.payload.webAppWidgetsInfo;
      state.currencyDetails = action.payload.currencyDetails;
    },
    setCurrentLayout: (state, action) => {
      state.currentLayout = action.payload;
      state.brandingColors = action.payload?.brandingInfo?.app?.menuWidget || {}
      state.currentLayoutId = action.payload?.durationId;
    },
    getDeviceConfigFailure: (state, action) => {
      state.initialLoading = false;
      state.loading = false;
      state.error = action.payload?.isError;
      state.errorMessage = action.payload?.errorMessage;
    },
    setCurrentWidget: (state, action) => {
      state.currentWidget = action.payload
    }
  },
});

export const {
  resetDeviceConfig,
  initDeviceConfigRequest,
  getDeviceConfigSuccess,
  setCurrentLayout,
  getDeviceConfigFailure,
  setCurrentWidget
} = deviceConfigSlice.actions;

export default deviceConfigSlice.reducer;
